/**
 * Stable CSS class names for E2E — Cut-off page, drawers, list & bulk tabs.
 */
export const COP = {
    page: 'cut-off-page',
    tabsSection: 'cut-off-page__tabs-section',
    tabs: 'cut-off-page__tabs',
    tabSlot: 'cut-off-page__tab-slot',
    tabPanel: 'cut-off-page__tab-panel',
    emptyState: 'cut-off-page__empty-state',
    inputButtonOpenSearch: 'cut-off-page-input--button-open-search',
} as const;

export const COSK = {
    drawerBody: 'cut-off-search-drawer__body',
    formFields: 'cut-off-search-drawer__form-fields',
    inputMenuSearch: 'cut-off-search-drawer-input--menu-search',
    fieldCargoCompany: 'cut-off-search-drawer-field--cargo-company',
    inputSelectCargoCompany: 'cut-off-search-drawer-input--select-cargo-company',
    fieldDistance: 'cut-off-search-drawer-field--distance',
    inputSelectDistance: 'cut-off-search-drawer-input--select-distance',
    fieldDeliveryType: 'cut-off-search-drawer-field--delivery-type',
    inputSelectDeliveryType: 'cut-off-search-drawer-input--select-delivery-type',
    fieldDepartureLocation: 'cut-off-search-drawer-field--departure-location',
    inputSelectDepartureLocation: 'cut-off-search-drawer-input--select-departure-location',
    fieldArrivalLocation: 'cut-off-search-drawer-field--arrival-location',
    inputSelectArrivalLocation: 'cut-off-search-drawer-input--select-arrival-location',
    fieldActiveStatus: 'cut-off-search-drawer-field--active-status',
    inputSelectActiveStatus: 'cut-off-search-drawer-input--select-active-status',
    actionsRow: 'cut-off-search-drawer__actions-row',
    inputButtonClear: 'cut-off-search-drawer-input--button-clear',
    inputButtonFilter: 'cut-off-search-drawer-input--button-filter',
} as const;

export const COLT = {
    root: 'cut-off-list-tab',
    toolbar: 'cut-off-list-tab__toolbar',
    inputButtonAddNew: 'cut-off-list-tab-input--button-add-new',
    inputButtonExportExcel: 'cut-off-list-tab-input--button-export-excel',
    datagridWrap: 'cut-off-list-tab__datagrid',
    inputIconRowActions: 'cut-off-list-tab-input--icon-button-row-actions',
} as const;

export const COBU = {
    root: 'cut-off-bulk-upload-tab',
    title: 'cut-off-bulk-upload-tab__title',
    description: 'cut-off-bulk-upload-tab__description',
    fieldCargoCompany: 'cut-off-bulk-upload-field--cargo-company',
    inputSelectCargoCompany: 'cut-off-bulk-upload-input--select-cargo-company',
    alertInfo: 'cut-off-bulk-upload-tab__alert-info',
    excelUploadWrap: 'cut-off-bulk-upload-tab__excel-upload-wrap',
    statusCounts: 'cut-off-bulk-upload-tab__status-counts',
    failedSection: 'cut-off-bulk-upload-tab__failed-section',
    failedTitle: 'cut-off-bulk-upload-tab__failed-title',
    failedTableWrap: 'cut-off-bulk-upload-tab__failed-table-wrap',
} as const;

export const COED = {
    drawerBody: 'cut-off-add-edit-drawer__body',
    formFields: 'cut-off-add-edit-drawer__form-fields',
    inputMenuSearch: 'cut-off-add-edit-drawer-input--menu-search',
    fieldCargoCompany: 'cut-off-add-edit-drawer-field--cargo-company',
    inputSelectCargoCompany: 'cut-off-add-edit-drawer-input--select-cargo-company',
    fieldDepartureLocation: 'cut-off-add-edit-drawer-field--departure-location',
    inputSelectDepartureLocation: 'cut-off-add-edit-drawer-input--select-departure-location',
    fieldArrivalLocation: 'cut-off-add-edit-drawer-field--arrival-location',
    inputSelectArrivalLocation: 'cut-off-add-edit-drawer-input--select-arrival-location',
    fieldDistance: 'cut-off-add-edit-drawer-field--distance',
    inputSelectDistance: 'cut-off-add-edit-drawer-input--select-distance',
    fieldDeliveryType: 'cut-off-add-edit-drawer-field--delivery-type',
    inputSelectDeliveryType: 'cut-off-add-edit-drawer-input--select-delivery-type',
    inputTextfieldCutOffTime: 'cut-off-add-edit-drawer-input--textfield-cut-off-time',
    inputTextfieldCommitmentDay: 'cut-off-add-edit-drawer-input--textfield-commitment-day',
    inputTextfieldValidFrom: 'cut-off-add-edit-drawer-input--textfield-valid-from',
    inputTextfieldValidTo: 'cut-off-add-edit-drawer-input--textfield-valid-to',
    rowActiveStatus: 'cut-off-add-edit-drawer__row-active-status',
    inputSwitchActiveStatus: 'cut-off-add-edit-drawer-input--switch-active-status',
    actionsRow: 'cut-off-add-edit-drawer__actions-row',
    inputButtonClear: 'cut-off-add-edit-drawer-input--button-clear',
    inputButtonSave: 'cut-off-add-edit-drawer-input--button-save',
} as const;

export const copCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const coskCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const coltCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const cobuCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const coedCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
